import { useTranslation } from "react-i18next";
import { observer } from "mobx-react-lite";

import { userStore } from "../../stores/userStore";

import "./WebGisConnectBlock.css";

const CONNECT_DOCS_URL = {
  en: "https://docs.nextgis.com/docs_howto/source/quick_webmap.html",
  ru: "https://docs.nextgis.ru/docs_howto/source/quick_webmap.html",
};

const CONNECT_VIDEO_URL = {
  en: "https://www.youtube.com/embed/dCuZuXztjPE",
  ru: "https://rutube.ru/play/embed/245deaf272e45ae5f6ab62c498f64e3f/",
};

export const WebGisConnectBlock = observer(function WebGisConnectBlock() {
  const { t } = useTranslation();
  const lang = userStore.isRuRegion ? "ru" : "en";
  const connectUrl = CONNECT_DOCS_URL[lang];
  const videoUrl = CONNECT_VIDEO_URL[lang];

  return (
    <div className="webgis-connect-block">
      <h4 className="webgis-connect-block__title">
        {t("webgis.connectTitle")}
      </h4>
      <p
        className="webgis-connect-block__desc"
        dangerouslySetInnerHTML={{
          __html: t("webgis.connectDescription", { url: connectUrl }),
        }}
      />
      <iframe
        className="webgis-connect-block__video"
        src={videoUrl}
        title={t("webgis.connectTitle")}
        style={{ border: 0 }}
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
        referrerPolicy="strict-origin-when-cross-origin"
        allowFullScreen
      />
    </div>
  );
});
